// Approximate centroids of the 14 departamentos of El Salvador.
// Used to auto-center the map picker after the user chooses a departamento.
// Coordinates in decimal degrees (lat, lng) — WGS84.
export const SV_DEPARTAMENTO_CENTROIDS = {
    2: { name: "Ahuachapán", lat: 13.9214, lng: -89.8450 },
    3: { name: "Cabañas", lat: 13.7239, lng: -88.7481 },
    4: { name: "Chalatenango", lat: 14.0339, lng: -88.9364 },
    5: { name: "Cuscatlán", lat: 13.7414, lng: -88.9319 },
    6: { name: "La Libertad", lat: 13.6772, lng: -89.3006 },
    7: { name: "La Paz", lat: 13.4917, lng: -88.9722 },
    8: { name: "La Unión", lat: 13.3369, lng: -87.8439 },
    9: { name: "Morazán", lat: 13.7692, lng: -88.1103 },
    10: { name: "San Miguel", lat: 13.4833, lng: -88.1833 },
    11: { name: "San Salvador", lat: 13.6929, lng: -89.2182 },
    12: { name: "San Vicente", lat: 13.6389, lng: -88.7847 },
    13: { name: "Santa Ana", lat: 13.9942, lng: -89.5597 },
    14: { name: "Sonsonate", lat: 13.7189, lng: -89.7239 },
    15: { name: "Usulután", lat: 13.3500, lng: -88.4500 },
};

export function centroidForDepartamento(id) {
    if (!id) return null;
    return SV_DEPARTAMENTO_CENTROIDS[parseInt(id)] || null;
}
